export default "__VITE_ASSET__B6IEgyT2__"